<template>
  <div>
    <div class="main-title">训练费月统计表</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-select
              v-model="searchForm.company_ids"
              multiple
              placeholder="选择科目"
              @change="search(searchForm)"
              style="width:250px;">
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="sqlcode" style="width:120px;" @change="search(searchForm)">
              <el-option label="按科目统计" value="report_bill_month"></el-option>
              <el-option label="按驾校统计" value="report_bill_month_school"></el-option>
              <el-option label="按教练统计" value="report_bill_month_coach"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchForm.year" style="width:140px" @change="search(searchForm)">
              <el-option label="2019年" value="2019"></el-option>
              <el-option label="2020年" value="2020"></el-option>
              <el-option label="2021年" value="2021"></el-option>
              <el-option label="2022年" value="2022"></el-option>
              <el-option label="2023年" value="2023"></el-option>
              <el-option label="2024年" value="2024"></el-option>
              <el-option label="2025年" value="2025"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        :summary-method="getSummaries"
        show-summary
        style="width:100%">
        <el-table-column
          prop="company_name"
          label="科目"
          v-if="sqlcode === 'report_bill_month'"
          width="120">
        </el-table-column>
        <el-table-column
          prop="school_name"
          label="驾校"
          v-if="sqlcode !== 'report_bill_month'"
          width="120">
        </el-table-column>
        <el-table-column
          prop="coach_name"
          label="教练"
          v-if="sqlcode === 'report_bill_month_coach'"
          width="120">
        </el-table-column>
        <el-table-column
          v-for="n in 12"
          :key="n"
          :prop="'t_' + n"
          :label="n + '月'"
          width="85">
        </el-table-column>
        <el-table-column
          prop="total"
          label="合计"
          width="100">
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import NP from 'number-precision'
export default {
  mixins: [ListFunc],
  data () {
    return {
      sqlcode: 'report_bill_month',
      searchForm: {
        company_ids: [],
        year: new Date().getFullYear().toString()
      },
      companyList: []
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  computed: {
    searchParams () {
      return this.searchForm
    }
  },
  mounted () {
    this.fetchCompanyList()
  },
  methods: {
    fetchCompanyList () { // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
          this.searchForm.company_ids = this.companyList.map(c => c.value)
        }
      })
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (column.property.indexOf('t') === 0) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return NP.plus(prev, curr)
            } else {
              return prev
            }
          }, 0)
        } else if (column.property === 'company_name') {
          sums[index] = '合计'
        } else if (column.property === 'school_name') {
          sums[index] = '本页合计'
        } else {
          sums[index] = ''
        }
      })
      return sums
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/report/Month.vue